import { useState } from 'react'

import { F0Checkbox, F0Dialog } from '@factorialco/f0-react'
import {
  AtsDeleteRequisitionDocument,
  AtsDeleteRequisitionMutation,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

interface Props {
  id: string
  onClose: () => void
  onSuccess?: () => void
}

export const DeleteRequisitionModal = ({ id, onClose, onSuccess }: Props) => {
  const [agreeCheckbox, setAgreeCheckbox] = useState(false)

  const [deleteRequisitionMutation, { loading }] = useMutation(AtsDeleteRequisitionDocument, {
    extractorFn: (data: AtsDeleteRequisitionMutation) => data.atsMutations.deleteAtsRequisition,
  })

  const onSubmit = async () => {
    const result = handleResult(
      await deleteRequisitionMutation({
        variables: { id },
        update(cache) {
          cache.evict({ id: cache.identify({ id, __typename: 'AtsRequisition' }) })
        },
      }),
      () => undefined
    )

    if (result.success) {
      app.setFlash({
        type: 'correct',
        message: i18n.t('common.removed_successfully'),
      })
      onClose()
      onSuccess?.()
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('ats.jobs_requisitions.delete_modal.error_message'),
      })
    }
  }

  return (
    <F0Dialog
      isOpen
      title={i18n.t('ats.jobs_requisitions.delete_modal.title')}
      description={i18n.t('ats.jobs_requisitions.delete_modal.description')}
      onClose={onClose}
      primaryAction={{
        label: i18n.t('common.delete'),
        onClick: onSubmit,
        disabled: loading || !agreeCheckbox,
        variant: 'critical',
      }}
      secondaryAction={{
        label: i18n.t('common.cancel'),
        onClick: onClose,
        disabled: loading,
      }}
    >
      <F0Checkbox
        checked={agreeCheckbox}
        onCheckedChange={(checked) => setAgreeCheckbox(checked === true)}
        title={i18n.t('ats.jobs_requisitions.delete_modal.checkbox_label')}
      />
    </F0Dialog>
  )
}
